import { AUTH_ENDPOINTS } from '../config/api.config';
import { ITokenResponse, ILoginDto, IRegisterDto } from '../types/auth.types';
import { TokenService } from './token.service';
import { UserService } from './user.service';

// Добавляем простой механизм оповещений
const authListeners: Array<(isLoggedIn: boolean) => void> = [];

export const AuthService = {
  // Добавляем метод для подписки на изменения статуса авторизации
  subscribe(callback: (isLoggedIn: boolean) => void) {
    authListeners.push(callback);
    return () => {
      const index = authListeners.indexOf(callback);
      if (index !== -1) {
        authListeners.splice(index, 1);
      }
    };
  },

  // Метод для оповещения всех подписчиков
  notifyListeners(isLoggedIn: boolean) {
    authListeners.forEach(listener => listener(isLoggedIn));
  },

  async register(data: IRegisterDto): Promise<void> {
    const response = await fetch(AUTH_ENDPOINTS.register(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Ошибка при регистрации');
    }
  },

  async login(data: ILoginDto): Promise<void> {
    console.log('Attempting login with:', data);
    const response = await fetch(AUTH_ENDPOINTS.login(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Ошибка при входе');
    }

    const tokenResponse = await response.json();
    console.log('Login response:', tokenResponse);
    this.setTokens(tokenResponse);
    await UserService.getProfile();
    this.notifyListeners(true); // Оповещаем о входе
  },

  async logout(): Promise<void> {
    console.log('Attempting logout');
    const token = TokenService.getToken();
    
    if (!token) {
      console.log('No token found, clearing storage');
      TokenService.clearStorage();
      this.notifyListeners(false); // Оповещаем о выходе
      return;
    }

    try {
      const response = await fetch(AUTH_ENDPOINTS.logout(), {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      console.log('Logout response status:', response.status);

      if (!response.ok) {
        const error = await response.json();
        console.error('Logout error:', error);
        throw new Error(error.message || 'Ошибка при выходе');
      }
    } catch (error) {
      console.error('Logout error:', error);
      throw error;
    } finally {
      console.log('Clearing storage after logout');
      TokenService.clearStorage();
      this.notifyListeners(false); // Оповещаем о выходе
    }
  },

  setTokens(response: ITokenResponse) {
    console.log('Setting tokens:', response);
    TokenService.saveToken(response.accessToken);
    TokenService.saveRefreshToken(response.refreshToken);
  },

  getUser() {
    const user = TokenService.getUser();
    console.log('Getting user from storage:', user);
    return user;
  }
}; 